const alwaysNoop = (...$$) => void $$;

export default alwaysNoop;
